if (typeof Clock !== 'function') {
    function Clock (countdown, callback) {
        countdown = countdown < new Date()? new Date() : countdown;
        countdown = countdown ? countdown : false
        callback = callback || function () {}
        var updateFn = countdown ? getTimeRemaining : getTime

        this.el = document.createElement('div')
        this.el.className = 'flip-clock'

        var trackers = {},
            t = updateFn(countdown),
            key,
            timeinterval

        for (key in t) {
            if (key === 'Total') {
                continue
            } else {
                trackers[key] = new CountdownTracker(key, t[key], false)
            }
            this.el.appendChild(trackers[key].el)
        }

        function CountdownTracker(label, value) {
            var el = document.createElement('span')
        
            el.className = 'flip-clock__piece'
            el.innerHTML =
                '<span class="flip-clock__card"><b class="card__time"></b></span>' +
                '<span class="flip-clock__slot">' +
                label +
                '</span>'
        
            this.el = el
            var card = el.querySelector('.card__time')
        
            this.update = function (val) {
                if (val !== this.currentValue) {
        
                    val = val.toString();
                    if(val.length === 1){
                        val = '0' + val;
                    }
                    this.currentValue = val
                    card.innerText = this.currentValue
        
                    this.el.classList.remove('flip')
                    void this.el.offsetWidth
                    this.el.classList.add('flip')
                }
            }
        
            this.update(value)
        }

        var i = 0
        function updateClock() {
            timeinterval = requestAnimationFrame(updateClock)
    
            if (i++ % 10) {
                return
            }
    
            var t = updateFn(countdown)
            if (t.Total < 0) {
                cancelAnimationFrame(timeinterval)
                for (key in trackers) {
                    trackers[key].update(0)
                }
                callback()
                return
            }
    
            for (key in trackers) {
                trackers[key].update(t[key])
            }
        }
        setTimeout(updateClock, 500)

        function getTime(){
            var t = new Date()
            return {
                Total: t,
                Hours: t.getHours() % 12,
                Minutes: t.getMinutes(),
                Seconds: t.getSeconds(),
            }
        }

        function getTimeRemaining(endtime){
            var t = endtime - new Date()
            current_location = window.location.href
        
            return {
                Total: t,
                Days: Math.floor(t / (1000 * 60 * 60 * 24)),
                Hours: Math.floor((t / (1000 * 60 * 60)) % 24),
                Minutes: Math.floor((t / 1000 / 60) % 60),
                Seconds: Math.floor((t / 1000) % 60),
            }
        }
    }
}

if(!customElements.get('custom-countdown-banner')){
    class CustomCountdownBanner extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.swiperContainer = this.querySelector('.swiper-container');
            if(this.querySelectorAll('.swiper-slide').length > 1){
                this.initSwiper();
            }else{
                if(this.querySelector('.swiper-navigation-wrapper'))
                    this.querySelector('.swiper-navigation-wrapper').setAttribute('data-hidden', 'true');
            }

            this.querySelectorAll('.swiper-slide').forEach(item => {
                var timerDate = (item.querySelector('.countdown-grid__timer'))? item.querySelector('.countdown-grid__timer').dataset.date : '';
                if(this.isValidDateFormat(timerDate)){
                    // set timer
                    var deadline = new Date(timerDate);
                    var counter = new Clock(deadline, function(){})
                    item.querySelector('.countdown-grid__timer').append(counter.el)
                }
            })
        }
        
        initSwiper(){
            var loop = (this.swiperContainer.dataset.loop == 'true')? true : false;

            var swiperSettings = {
                init: false,
                initialSlide: 0,
                loop: loop,
                spaceBetween: 0,
                centeredSlides: false,
                slidesPerView: 1,
                speed: 500,
                watchOverflow: true,
                observer: true,
                observeSlideChildren: true
            }

            if(this.swiperContainer.querySelector('.swiper-button-next')){
                swiperSettings.navigation = {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev')
                }
            }

            if(this.swiperContainer.dataset.transitionEffect == 'fade'){
                swiperSettings.effect = 'fade';
                swiperSettings.fadeEffect = {
                    crossFade: true
                }
            }

            if(this.swiperContainer.dataset.autoplay == 'true'){
                let speed = this.swiperContainer.dataset.speed;
                speed = parseInt(speed) * 1000;
                swiperSettings.autoplay = {
                    delay: speed
                }
            }

            this.swiper = new Swiper(this.swiperContainer, swiperSettings);
            this.swiper.init();
            this.getVisibleSlides();
            this.checkPagination();

            this.swiper.on('slideChange', () => {
                this.getVisibleSlides();
            });

            this.swiper.on("resize", () => {
                this.checkPagination();
            });

            this.swiper.on('slideChangeTransitionEnd', () => {
                const currentIndex = this.swiper.activeIndex;
                const currentSlide = this.swiper.slides[currentIndex];
                
                if(currentSlide) this.swiperContainer.setAttribute('data-current-idx', currentSlide.querySelector('.countdown-banner__col').dataset.idx);
            });
        }

        getVisibleSlides(){
            if(this.swiper){
                const allSlides = this.swiper.slides;
                const activeIndex = this.swiper.activeIndex;
                const slidesPerView = this.swiper.params.slidesPerView;

                const visibleSlides = [];
                
                if(slidesPerView === 'auto'){
                    allSlides.forEach((slide) => {
                        const rect = slide.getBoundingClientRect();
                        if (rect.left >= 0 && rect.right <= window.innerWidth) {
                            visibleSlides.push(slide);
                        }
                    });
                }else{
                    for (let i = activeIndex; i < activeIndex + slidesPerView && i < allSlides.length; i++) {
                        visibleSlides.push(allSlides[i]);
                    }
                }
    
                allSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '-1');
                    });
                });
    
                visibleSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '0');
                    });
                });
            }
        }

        checkPagination(){
            var pagination = this.querySelector('.swiper-pagination');
            var btns = {
                prev: this.querySelector('.swiper-button-prev'),
                next: this.querySelector('.swiper-button-next')
            }
            if(pagination && pagination.querySelectorAll('.swiper-pagination-bullet').length <= 1){
                pagination.classList.add('d-none');
                if(btns.prev) btns.prev.style.display = 'none';
                if(btns.next) btns.next.style.display = 'none';
            }else{
                if(pagination) pagination.classList.remove('d-none');
                if(btns.prev) btns.prev.style.display = 'block';
                if(btns.next) btns.next.style.display = 'block';
            }
        }

        isValidDateFormat(dateString) {
            var dateFormatRegex = /^\d{4}\/\d{2}\/\d{2}$/;
            return dateFormatRegex.test(dateString);
        }

        refresh(){
            if(this.querySelectorAll('.swiper-slide').length > 1){
                this.initSwiper();
            }else{
                if(this.querySelector('.swiper-navigation-wrapper'))
                    this.querySelector('.swiper-navigation-wrapper').setAttribute('data-hidden', 'true');
            }
        }
    }

    customElements.define('custom-countdown-banner', CustomCountdownBanner);
}